export const Chevron = (): JSX.Element => {
  return (
    <svg viewBox="0 0 16 9" xmlns="http://www.w3.org/2000/svg">
      <path d="M7.99756 8.54707C7.66756 8.54707 7.35756 8.41707 7.12756 8.18707L0.217561 1.27707C-0.072439 0.987073 -0.072439 0.507073 0.217561 0.217073C0.507561 -0.0729272 0.987561 -0.0729272 1.27756 0.217073L7.99756 6.93707L14.7176 0.217073C15.0076 -0.0729272 15.4876 -0.0729272 15.7776 0.217073C16.0676 0.507073 16.0676 0.987073 15.7776 1.27707L8.86756 8.18707C8.63756 8.41707 8.32756 8.54707 7.99756 8.54707Z" />
    </svg>
  )
}
